import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Sidebar from "@/components/Sidebar";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Apps from "@/pages/Apps";
import AppDetail from "@/pages/AppDetail";
import { DevelopersList, DeveloperDetail } from "@/pages/Developers";
import Leads from "@/pages/Leads";
import Opportunities from "@/pages/Opportunities";
import FreshLaunches from "@/pages/FreshLaunches";
import Admin from "@/pages/Admin";
import Alerts from "@/pages/Alerts";
import { Toaster } from "@/components/ui/sonner";

function Layout() {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (user === false) nav("/login", { replace: true, state: { from: loc.pathname } });
  }, [user, nav, loc.pathname]);

  if (user == null) return <div className="p-10 text-sm text-muted-foreground">Loading…</div>;
  if (user === false) return null;

  return (
    <div className="flex h-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/apps" element={<Apps />} />
              <Route path="/fresh" element={<FreshLaunches />} />
              <Route path="/low-rated" element={<Apps preset={{ title: "Low Rated Apps", max_rating: 3.5 }} />} />
              <Route path="/rating-drops" element={<Apps preset={{ title: "Rating Drops" }} />} />
              <Route path="/apps/:pkg" element={<AppDetail />} />
              <Route path="/developers" element={<DevelopersList />} />
              <Route path="/developers/:id" element={<DeveloperDetail />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
